import React, {useEffect, useState} from "react";
import Strings from "../../config/Strings";
import {GetEmailConfirmationRequired} from "./DashboardService";
import "./EmailConfirmationHint.scss";
import {ResendActivationMail} from "../../global/resend-activation-mail/ResendActivationMail";

//Shows a hint if the account has to confirm its email before existing billwerk contracts can be taken over.
//A failing request never blocks anything - the hint is simply not shown.
export function EmailConfirmationHint({accountId}) {

    const [emailConfirmationRequired, setEmailConfirmationRequired] = useState(false);

    useEffect(() => {
        let active = true;
        if (accountId == null) {
            setEmailConfirmationRequired(false);
            return;
        }
        GetEmailConfirmationRequired()
            .then(response => {
                if (active && !response.error) {
                    setEmailConfirmationRequired(response.result?.emailConfirmationRequired === true);
                }
            })
            .catch(() => {});
        return () => {
            active = false;
        };
    }, [accountId]);

    if (!emailConfirmationRequired) {
        return null;
    }

    return (
        <div role="alert" className="email-confirmation-hint">
            {Strings.EMAIL_CONFIRMATION_REQUIRED}
            <ResendActivationMail accountId={accountId}/>
        </div>
    );
}
